/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Cta_DownloadInputs */

const en_home_hero_cta_download = /** @type {(inputs: Home_Hero_Cta_DownloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download free`)
};

/**
* | output |
* | --- |
* | "Download free" |
*
* @param {Home_Hero_Cta_DownloadInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const home_hero_cta_download = /** @type {((inputs?: Home_Hero_Cta_DownloadInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Cta_DownloadInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_home_hero_cta_download(inputs)
});
export { home_hero_cta_download as "home.hero.cta_download" }